import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { useDispatch, useSelector } from 'react-redux';

import { createItemAction } from '../../../store/actions/ItemActions';

const Item = (props) => {

    
    const dispatch = useDispatch();
    const [submit, setSubmit] = useState(false);
    const [variant, setVariant] = useState(false);

    const [item, setItem] = useState({
        name: "",
        image: "",
        description: "",
        category_id: "",
        price: "",
        item_group_id: [],
       // response: [],
    });

   
    const [multiInput, setMultiInput] = useState([
        {
            variationName: '',
            variationPrice: ''
        },
    ]);

    //console.log(item);
    //console.log(multiInput);

    
    // handle click event of the Add button
    const handleAddClick = (e) => {
        e.preventDefault();
        setVariant(true);
        setItem({
            ...item,
            price: 0
        });
        setMultiInput([
            ...multiInput,
            { variationName: '', variationPrice: '' },
        ]);
    };



    // handle input change
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const inputList = [...multiInput];
        inputList[index][name] = value;
        setMultiInput(inputList);
    };


    const categories = useSelector((state) => state.allItems?.items?.payload?.categories);
    const allItemGroups = useSelector((state) => state.allItems?.items?.payload?.itemGroups);
    
   
    const categoryOption = categories?.map(category => {
        const option = {};
        option['value'] = category.id;
        option['label'] = category.name;
        //option['name'] = 'category_id';
        return option;
    });


    function onFormFieldChange(e) {
       
        if ((item.name != '') && (item.price != '')) {
            setSubmit(true);
        } else {
            setSubmit(false);
        }

        setItem({
            ...item,
            [e.target.name]: e.target.value
        });
    }


    function onChekboxChange(e) {
      
        const { value, checked } = e.target;
        const { item_group_id } = item;
        if (checked) {
            setItem({
                ...item,
                item_group_id: [...item_group_id, value],
               // response: [...item_group_id, value],
            });
        } else {
            setItem({
                ...item,
                item_group_id: item_group_id.filter((e) => e !== value),
               // response: item_group_id.filter((e) => e !== value),
            });
        }
        
    }

    console.log(item);


    useEffect(() => {
        if ((item.name != '') && (item.price != '')) {
            setSubmit(true);
        } else {
            setSubmit(false);
        }

    }, [item.price, item.name]);

    function onFormSelectChange(event) {

        setItem({
            ...item,
            [event.target.name]: event.target.value
        });
    }


    function onFormSubmit(e) {
        e.preventDefault();
        try {
            let itemObj = {
                ...item, variation: multiInput
            }
            console.log(itemObj)
           // dispatch(createItemAction(itemObj, props.history));
        } catch (error) {
            console.log("Something is wrong");
        }
    }


    return (
        <div className='add-item'>
            <div style={{ height: "300vh" }}>
                <form>
                    <div className="card rounded-0 mb-0">
                        <div className="card-header">
                            <h5>Item Details</h5>
                            {submit ? <button className='btn btn-xs rounded-0' type='submit' onClick={onFormSubmit} style={{ color: 'white', backgroundColor: '#000000' }}>Save</button> : ''}
                        </div>
                        <div className="card-rounded-0 upload-item-card mt-3">
                            <div className="card-body upload-body">
                                <div className='col-md-9 col-lg-9'>
                                    <span>There is no dish photo. Items sells better when they have a well-taken
                                        photo.</span>
                                    <p>1000 x 731 pixels minimum (JPG, 10 MB maximum)  </p>

                                    <div className='d-flex pt-2'>
                                        <label htmlFor='item-image' style={{ color: '#2c8dc8', cursor: 'pointer' }}> <i className='mdi mdi-image' style={{ color: '#2c8dc8' }}> </i> UPLOAD DISH PHOTO </label>
                                        <input type='file' id='item-image' className='d-none' />
                                        <small className='ms-2 '>or drag it in?</small>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="mt-2 input-item">
                                <TextField id="standard-basic" name="name" label="Item Name *" variant="standard" onChange={onFormFieldChange} />
                                <small>Example: Cheese Pizza, Fried Rice,Apple Juice</small>
                            </div>
                            <div className="form-group input-item mt-3">
                                <TextField id="standard-basic" name="description" label="Item Description-(optional)" variant="standard" onChange={onFormFieldChange} />
                                <small>Example: Cheese Pizzais very tasty</small>
                            </div>
                            <div className="mt-2">
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 535 }}>
                                    <InputLabel id="demo-simple-select-standard-label">Category</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        value={item?.category_id}
                                        onChange={onFormSelectChange}
                                        label="Category"
                                        name="category_id"
                                    >
                                        {categoryOption?.map((option) => (
                                            <MenuItem key={option?.value} value={option?.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </div>
                        </div>
                    </div>

                    <div className="card-rounded-0 add-item-card mt-3">
                        <div className="card-body">
                            <h5>Prices and Variation</h5>
                            <small className='mt-1'> Add a variation if this item comes in different Sizes(e.g. Small, Medium, Large) or options (e.g Soup, Dry) include GST/VAT in prices if applicable.</small>

                            {!variant &&
                                <div className=" mb-4 mt-5">
                                    <TextField
                                        id="price"
                                        defaultValue="Tk"
                                        label="Price *"
                                        name="price"
                                        type="number"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        variant="standard"
                                        onChange={onFormFieldChange}
                                    />
                                </div>

                            }

                            {
                                variant &&
                                multiInput.map((data, index) =>
                                    <div key={index} className='card rounded-0 border mt-3 pl-3'>
                                        <div className=" mt-3">
                                            <TextField id="standard-basic" name='variationName' label="Variation Name" variant="standard" onChange={(e) => handleInputChange(e, index)} />
                                        </div>

                                        <div className="mt-5 mb-4">
                                            <TextField
                                                id="price"
                                                label="Price *"
                                                name="variationPrice"
                                                type="number"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                variant="standard"
                                                onChange={(e) => handleInputChange(e, index)}
                                            />
                                        </div>
                                    </div>
                                )

                            }
                            <span onClick={handleAddClick} className='add-variation'> <i className='mdi mdi-plus'></i>  ADD VARIATIONS</span>
                        </div>
                    </div>
                    <div className="card-rounded-0 add-item-card mt-3">
                        <div className="card-body">
                            <h5>Choice Groupes</h5>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <td>Name</td>
                                        <td>Choices</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        allItemGroups.map(item=>
                                        <tr>
                                            <td className='d-flex align-items-center'>
                                                    <input type='checkbox' onChange={onChekboxChange}
                                                        name='item_group_id'
                                                        value={item?.id}
                                                        key={item?.id}
                                                          />
                                                    <span className='ms-2'>{item?.name}</span>
                                            </td>
                                            <td>
                                                    <span>{item?.ingredients} </span>
                                            </td>
                                        </tr>
                                        )}
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Item;